webpackJsonp([1],{

/***/ "++5V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar",style:(_vm.sidebarStyle),attrs:{"data-color":_vm.backgroundColor,"data-image":_vm.backgroundImage}},[_c('div',{staticClass:"sidebar-wrapper"},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text",attrs:{"href":"/quotes"}},[_vm._m(0),_vm._v("\n                "+_vm._s(_vm.title)+"\n            ")])]),_vm._v(" "),_vm._t("content"),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._t("default",function(){return _vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-link',{key:link.name + index,attrs:{"to":link.path,"link":link},on:{"click":_vm.closeNavbar}},[_c('i',{class:link.icon}),_vm._v(".nav-link\n                    "),_c('p',[_vm._v(_vm._s(link.name))])])})})],2)],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-img"},[_c('img')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);


/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

var GlobalDirectives = {
    install: function install(Vue) {
        Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+cI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'nav-open': _vm.$sidebar.showSidebar}},[_c('notifications'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+iwA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__ = __webpack_require__("Pfth");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c35e949e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__ = __webpack_require__("vHPY");
function injectStyle (ssrContext) {
  __webpack_require__("5sFA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c35e949e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Categories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c35e949e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Categories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/4dZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Bd9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n                © 2017, made with\n                "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n            ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/if8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.image.is_premium),expression:"image.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.image.is_premium)?_vm._i(_vm.image.is_premium,null)>-1:(_vm.image.is_premium)},on:{"change":function($event){var $$a=_vm.image.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.image, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.image, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.image, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.image.category_id),expression:"image.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.image, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.image.status),expression:"image.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.image, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.image.sort),callback:function ($$v) {_vm.$set(_vm.image, "sort", $$v)},expression:"image.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Фон: "),(_vm.image.url)?_c('span',[_c('a',{attrs:{"href":_vm.image.url_full,"target":"_blank"}},[_vm._v("(ссылка)")])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"urlFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'url')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.urlFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"device-block device1"},[_c('img',{attrs:{"src":_vm.image.url_full}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Фон (превью): "),(_vm.image.url_small)?_c('span',[_c('a',{attrs:{"href":_vm.image.url_small_full,"target":"_blank"}},[_vm._v("(ссылка)")])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"urlSmallFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'url_small')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.urlSmallFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"device-block device1"},[_c('img',{attrs:{"src":_vm.image.url_small_full}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "06xA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Фоны")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('ii_category', _vm.categoryId)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('ii_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить фон\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'url_small_full')?_c('span',[_vm._v("фон")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'is_premium')?_c('span',[_vm._v("премиум")]):(column === 'category')?_c('span',[_vm._v("категория")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'is_premium')?_c('span',[(item[column] === 1)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/premium.png"}}):_vm._e()]):(column === 'url_small_full')?_c('div',{on:{"click":function($event){return _vm.edit(item['id'])}}},[_c('div',{staticClass:"device-block device1",style:({ backgroundImage: 'url(' + item[column] + ')', backgroundPosition: 'center center' })})]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активен")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активен")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0AeP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('side-bar',[_c('mobile-menu',{attrs:{"slot":"content"},slot:"content"}),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/categories"}},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("Категории цитат")])]):_vm._e(),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/quotes"}},[_c('i',{staticClass:"nc-icon nc-chat-round"}),_vm._v(" "),_c('p',[_vm._v("Цитаты")])]):_vm._e(),_vm._v(" "),(_vm.role < 2)?_c('sidebar-link',{attrs:{"to":"/images-categories"}},[_c('i',{staticClass:"nc-icon nc-tablet-2"}),_vm._v(" "),_c('p',[_vm._v("Категории фонов")])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"resetspan",on:{"click":_vm.resetOffsets}},[_c('sidebar-link',{attrs:{"to":"/images"}},[_c('i',{staticClass:"nc-icon nc-album-2"}),_vm._v(" "),_c('p',[_vm._v("Фоны")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_vm._v(" "),_c('dashboard-content',{on:{"click":_vm.toggleSidebar}}),_vm._v(" "),_c('content-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0AsC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__("MDnB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629d6826_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__("G0RX");
function injectStyle (ssrContext) {
  __webpack_require__("7707")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629d6826_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0FOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "0hnZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("aKLM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6b7c59_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("OG0z");
function injectStyle (ssrContext) {
  __webpack_require__("J3Wr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a6b7c59"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a6b7c59_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0lO5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Images_vue__ = __webpack_require__("C+KY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d25639d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Images_vue__ = __webpack_require__("06xA");
function injectStyle (ssrContext) {
  __webpack_require__("uaxE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d25639d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Images_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d25639d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Images_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0uxu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _ = __webpack_require__("M4fF");

var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            image: null,
            locales: [],
            categories: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/images/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.image = data.image;
                self.categories = data.categories;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var image = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.image));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/images/' + this.id + '/update', image, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0424\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.image['' + type] = data.url;
                self.image[type + '_full'] = data.url_full;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }

    }
});

/***/ }),

/***/ "1lSy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");



/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

var GlobalComponents = {
    install: function install(Vue) {
        Vue.component('fg-input', __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
        Vue.component('drop-down', __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "28ys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_v_tooltip__ = __webpack_require__("VN6J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__globalComponents__ = __webpack_require__("1lSy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__ = __webpack_require__("Sczw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_notifyjs_themes_default_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__ = __webpack_require__("/4dZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_sass_light_bootstrap_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__ = __webpack_require__("947H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_css_demo_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_es6_promise_auto__);

// Notifications plugin

// A plugin file where you could register global components used across the app

// A plugin file where you could register global directives

// Sidebar on the right. Used as a local plugin in DashboardLayout.vue


// asset imports





// library auto imports


/**
 * This is the main Light Bootstrap Dashboard Vue plugin where dashboard related plugins are registerd.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
    install: function install(Vue) {
        Vue.use(__WEBPACK_IMPORTED_MODULE_2__globalComponents__["a" /* default */]);
        Vue.use(__WEBPACK_IMPORTED_MODULE_3__globalDirectives__["a" /* default */]);
        Vue.use(__WEBPACK_IMPORTED_MODULE_4__components_UIComponents_SidebarPlugin__["a" /* default */]);
        Vue.use(__WEBPACK_IMPORTED_MODULE_1_vue_notifyjs___default.a);
        Vue.use(__WEBPACK_IMPORTED_MODULE_0_v_tooltip__["a" /* default */]);
    }
});

/***/ }),

/***/ "2aTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__ = __webpack_require__("zTLC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77256d8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__ = __webpack_require__("U6AA");
function injectStyle (ssrContext) {
  __webpack_require__("DomV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77256d8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNavbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77256d8a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNavbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Q3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inheritAttrs: false,
    inject: {
        autoClose: {
            default: true
        }
    },
    props: {
        link: {
            type: [String, Object],
            default: function _default() {
                return {
                    name: '',
                    path: '',
                    icon: ''
                };
            }
        },
        tag: {
            type: String,
            default: 'router-link'
        }
    },
    methods: {
        hideSidebar: function hideSidebar() {
            if (this.autoClose && this.$sidebar && this.$sidebar.showSidebar === true) {
                this.$sidebar.displaySidebar(false);
            }
        }
    }
});

/***/ }),

/***/ "3bYy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("iU4o");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7785091b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("HbuU");
function injectStyle (ssrContext) {
  __webpack_require__("SCCf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7785091b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7785091b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4pBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("PBKA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4756a8f9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("KaWC");
function injectStyle (ssrContext) {
  __webpack_require__("DCn3")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4756a8f9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4756a8f9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ce65de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("/Bd9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32ce65de_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5sFA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "75oI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7707":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7OHa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("UMJ7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f379faa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("/if8");
function injectStyle (ssrContext) {
  __webpack_require__("75oI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f379faa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f379faa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7SdG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__ = __webpack_require__("3Q3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00f7cbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__ = __webpack_require__("J6wH");
function injectStyle (ssrContext) {
  __webpack_require__("GhUe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d00f7cbe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "947H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C+KY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'url_small_full', 'category', 'is_premium', 'sort', 'status', ''],
            limit: 10,
            offset: parseInt(localStorage.getItem('ii_active_offset')) || 0,
            data: [],
            categories: [],
            status: localStorage.getItem('ii_status') ? localStorage.getItem('ii_status') : "",
            categoryId: localStorage.getItem('ii_category') ? localStorage.getItem('ii_category') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.offset = 0;
            localStorage.setItem('ii_active_offset', parseInt(this.offset));

            this.get();
        },
        add: function add() {
            this.$router.push('/images/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/images/', {
                'params': {
                    status: this.status,
                    categoryId: self.categoryId,
                    limit: self.limit,
                    offset: self.offset
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data.images;

                self.categories = response.data.categories;
                localStorage.setItem('ii_categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.categories));

                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-image',
                params: { id: id }
            });
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('ii_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('ii_active_offset', parseInt(this.offset));
            }
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }

    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('images') < 1) {
            localStorage.setItem('ii_active_offset', "");
            localStorage.setItem('ii_category', "");
            localStorage.setItem('ii_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__ = __webpack_require__("7SdG");



var SidebarStore = {
    showSidebar: false,
    sidebarLinks: [{
        name: 'Dashboard',
        icon: 'ti-panel',
        path: '/admin/overview'
    }],
    displaySidebar: function displaySidebar(value) {
        this.showSidebar = value;
    }
};

var SidebarPlugin = {
    install: function install(Vue) {
        Vue.mixin({
            data: function data() {
                return {
                    sidebarStore: SidebarStore
                };
            }
        });

        Object.defineProperty(Vue.prototype, '$sidebar', {
            get: function get() {
                return this.$root.sidebarStore;
            }
        });
        Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
        Vue.component('sidebar-link', __WEBPACK_IMPORTED_MODULE_1__SidebarLink_vue__["a" /* default */]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "D2tc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DCn3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DomV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EGO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("100 Awesome Nucleo Icons")]),_vm._v(" "),_c('p',{staticClass:"card-category"},[_vm._v("Handcrafted by our friends from "),_c('a',{attrs:{"target":"_blank","href":"https://nucleoapp.com/?ref=1712"}},[_vm._v("NucleoApp")])])]),_vm._v(" "),_c('div',{staticClass:"all-icons"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-air-baloon"}),_vm._v(" "),_c('p',[_vm._v("nc-air-baloon")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-album-2"}),_vm._v(" "),_c('p',[_vm._v("nc-album-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-alien-33"}),_vm._v(" "),_c('p',[_vm._v("nc-alien-33")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-align-center"}),_vm._v(" "),_c('p',[_vm._v("nc-align-center")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-align-left-2"}),_vm._v(" "),_c('p',[_vm._v("nc-align-left-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-ambulance"}),_vm._v(" "),_c('p',[_vm._v("nc-ambulance")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-android"}),_vm._v(" "),_c('p',[_vm._v("nc-android")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-app"}),_vm._v(" "),_c('p',[_vm._v("nc-app")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-apple"}),_vm._v(" "),_c('p',[_vm._v("nc-apple")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-atom"}),_vm._v(" "),_c('p',[_vm._v("nc-atom")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-attach-87"}),_vm._v(" "),_c('p',[_vm._v("nc-attach-87")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-audio-92"}),_vm._v(" "),_c('p',[_vm._v("nc-audio-92")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-backpack"}),_vm._v(" "),_c('p',[_vm._v("nc-backpack")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-badge"}),_vm._v(" "),_c('p',[_vm._v("nc-badge")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bag"}),_vm._v(" "),_c('p',[_vm._v("nc-bag")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bank"}),_vm._v(" "),_c('p',[_vm._v("nc-bank")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-battery-81"}),_vm._v(" "),_c('p',[_vm._v("nc-battery-81")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bell-55"}),_vm._v(" "),_c('p',[_vm._v("nc-bell-55")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bold"}),_vm._v(" "),_c('p',[_vm._v("nc-bold")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bulb-63"}),_vm._v(" "),_c('p',[_vm._v("nc-bulb-63")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bullet-list-67"}),_vm._v(" "),_c('p',[_vm._v("nc-bullet-list-67")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-bus-front-12"}),_vm._v(" "),_c('p',[_vm._v("nc-bus-front-12")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-pause"}),_vm._v(" "),_c('p',[_vm._v("nc-button-pause")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-play"}),_vm._v(" "),_c('p',[_vm._v("nc-button-play")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-button-power"}),_vm._v(" "),_c('p',[_vm._v("nc-button-power")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-camera-20"}),_vm._v(" "),_c('p',[_vm._v("nc-camera-20")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-caps-small"}),_vm._v(" "),_c('p',[_vm._v("nc-caps-small")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cart-simple"}),_vm._v(" "),_c('p',[_vm._v("nc-cart-simple")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cctv"}),_vm._v(" "),_c('p',[_vm._v("nc-cctv")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-bar-32"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-bar-32")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-pie-35"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-pie-35")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart-pie-36"}),_vm._v(" "),_c('p',[_vm._v("nc-chart-pie-36")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chart"}),_vm._v(" "),_c('p',[_vm._v("nc-chart")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-chat-round"}),_vm._v(" "),_c('p',[_vm._v("nc-chat-round")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-check-2"}),_vm._v(" "),_c('p',[_vm._v("nc-check-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-circle-09"}),_vm._v(" "),_c('p',[_vm._v("nc-circle-09")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-circle"}),_vm._v(" "),_c('p',[_vm._v("nc-circle")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cloud-download-93"}),_vm._v(" "),_c('p',[_vm._v("nc-cloud-download-93")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-cloud-upload-94"}),_vm._v(" "),_c('p',[_vm._v("nc-cloud-upload-94")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-compass-05"}),_vm._v(" "),_c('p',[_vm._v("nc-compass-05")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-controller-modern"}),_vm._v(" "),_c('p',[_vm._v("nc-controller-modern")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-credit-card"}),_vm._v(" "),_c('p',[_vm._v("nc-credit-card")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-delivery-fast"}),_vm._v(" "),_c('p',[_vm._v("nc-delivery-fast")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-email-83"}),_vm._v(" "),_c('p',[_vm._v("nc-email-83")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-email-85"}),_vm._v(" "),_c('p',[_vm._v("nc-email-85")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-explore-2"}),_vm._v(" "),_c('p',[_vm._v("nc-explore-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-fav-remove"}),_vm._v(" "),_c('p',[_vm._v("nc-fav-remove")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-favourite-28"}),_vm._v(" "),_c('p',[_vm._v("nc-favourite-28")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-globe-2"}),_vm._v(" "),_c('p',[_vm._v("nc-globe-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-grid-45"}),_vm._v(" "),_c('p',[_vm._v("nc-grid-45")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-headphones-2"}),_vm._v(" "),_c('p',[_vm._v("nc-headphones-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-html5"}),_vm._v(" "),_c('p',[_vm._v("nc-html5")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-istanbul"}),_vm._v(" "),_c('p',[_vm._v("nc-istanbul")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-key-25"}),_vm._v(" "),_c('p',[_vm._v("nc-key-25")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-layers-3"}),_vm._v(" "),_c('p',[_vm._v("nc-layers-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-light-3"}),_vm._v(" "),_c('p',[_vm._v("nc-light-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-lock-circle-open"}),_vm._v(" "),_c('p',[_vm._v("nc-lock-circle-open")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-map-big"}),_vm._v(" "),_c('p',[_vm._v("nc-map-big")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-mobile"}),_vm._v(" "),_c('p',[_vm._v("nc-mobile")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-money-coins"}),_vm._v(" "),_c('p',[_vm._v("nc-money-coins")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-note-03"}),_vm._v(" "),_c('p',[_vm._v("nc-note-03")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-notes"}),_vm._v(" "),_c('p',[_vm._v("nc-notes")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-notification-70"}),_vm._v(" "),_c('p',[_vm._v("nc-notification-70")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-palette"}),_vm._v(" "),_c('p',[_vm._v("nc-palette")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-paper-2"}),_vm._v(" "),_c('p',[_vm._v("nc-paper-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-pin-3"}),_vm._v(" "),_c('p',[_vm._v("nc-pin-3")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-planet"}),_vm._v(" "),_c('p',[_vm._v("nc-planet")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-preferences-circle-rotate"}),_vm._v(" "),_c('p',[_vm._v("nc-preferences-circle-rotate")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-puzzle-10"}),_vm._v(" "),_c('p',[_vm._v("nc-puzzle-10")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-quote"}),_vm._v(" "),_c('p',[_vm._v("nc-quote")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-refresh-02"}),_vm._v(" "),_c('p',[_vm._v("nc-refresh-02")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-ruler-pencil"}),_vm._v(" "),_c('p',[_vm._v("nc-ruler-pencil")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-satisfied"}),_vm._v(" "),_c('p',[_vm._v("nc-satisfied")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-scissors"}),_vm._v(" "),_c('p',[_vm._v("nc-scissors")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-send"}),_vm._v(" "),_c('p',[_vm._v("nc-send")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-90"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-90")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-gear-64"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-gear-64")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-settings-tool-66"}),_vm._v(" "),_c('p',[_vm._v("nc-settings-tool-66")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-add"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-add")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-delete"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-delete")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-simple-remove"}),_vm._v(" "),_c('p',[_vm._v("nc-simple-remove")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-single-02"}),_vm._v(" "),_c('p',[_vm._v("nc-single-02")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-single-copy-04"}),_vm._v(" "),_c('p',[_vm._v("nc-single-copy-04")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-spaceship"}),_vm._v(" "),_c('p',[_vm._v("nc-spaceship")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-square-pin"}),_vm._v(" "),_c('p',[_vm._v("nc-square-pin")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-down"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-down")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-left"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-left")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-right"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-right")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-stre-up"}),_vm._v(" "),_c('p',[_vm._v("nc-stre-up")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-sun-fog-29"}),_vm._v(" "),_c('p',[_vm._v("nc-sun-fog-29")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-support-17"}),_vm._v(" "),_c('p',[_vm._v("nc-support-17")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tablet-2"}),_vm._v(" "),_c('p',[_vm._v("nc-tablet-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tag-content"}),_vm._v(" "),_c('p',[_vm._v("nc-tag-content")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tap-01"}),_vm._v(" "),_c('p',[_vm._v("nc-tap-01")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-time-alarm"}),_vm._v(" "),_c('p',[_vm._v("nc-time-alarm")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-tv-2"}),_vm._v(" "),_c('p',[_vm._v("nc-tv-2")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-umbrella-13"}),_vm._v(" "),_c('p',[_vm._v("nc-umbrella-13")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-vector"}),_vm._v(" "),_c('p',[_vm._v("nc-vector")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-watch-time"}),_vm._v(" "),_c('p',[_vm._v("nc-watch-time")])])]),_vm._v(" "),_c('div',{staticClass:"font-icon-list col-lg-2 col-md-3 col-sm-4 col-6"},[_c('div',{staticClass:"font-icon-detail"},[_c('i',{staticClass:"nc-icon nc-zoom-split"}),_vm._v(" "),_c('p',[_vm._v("nc-zoom-split")])])])])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EplD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateQuote',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            quote: {
                status: 0,
                category_id: null,
                translations: [],
                sort: 1
            },
            locales: [],
            categories: JSON.parse(localStorage.getItem('qq_categories'))
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var quote = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quote));

            quote.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/quotes/create', quote, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0426\u0438\u0442\u0430\u0442\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/quotes');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "G0RX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-mobile-menu"},[_c('drop-down',[_c('template',{slot:"title"},[_c('i',{staticClass:"fa fa-globe"}),_vm._v(" "),_c('b',{staticClass:"caret"}),_vm._v(" "),_c('span',{staticClass:"notification"},[_vm._v("5 Notifications")])]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 1")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 2")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 3")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Notification 4")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Another notification")])],2),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('drop-down',{attrs:{"title":"Dropdown"}},[_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Action")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Another action")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Something")]),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Something else here")]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_vm._v("Separated link")])]),_vm._v(" "),_vm._m(1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#"}},[_c('i',{staticClass:"nc-icon nc-zoom-split hidden-lg-up"}),_vm._v(" "),_c('span',{staticClass:"d-lg-none"},[_vm._v("Search")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#pablo"}},[_c('span',{staticClass:"no-icon"},[_vm._v("Выйти")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GhUe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HRq4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.is_premium),expression:"category.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.category.is_premium)?_vm._i(_vm.category.is_premium,null)>-1:(_vm.category.is_premium)},on:{"change":function($event){var $$a=_vm.category.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.category, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.category, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.category, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.status),expression:"category.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.category.sort),callback:function ($$v) {_vm.$set(_vm.category, "sort", $$v)},expression:"category.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.category.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HTVk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HbuU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.status),expression:"category.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.category.sort),callback:function ($$v) {_vm.$set(_vm.category, "sort", $$v)},expression:"category.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество цитат в категории","placeholder":"","readonly":""},model:{value:(_vm.category.count),callback:function ($$v) {_vm.$set(_vm.category, "count", $$v)},expression:"category.count"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.category.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IRFK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J3Wr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J6wH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,_vm._b({tag:"component",attrs:{"tag":"li"},nativeOn:{"click":function($event){return _vm.hideSidebar.apply(null, arguments)}}},'component',_vm.$attrs,false),[_c('a',{staticClass:"nav-link"},[_vm._t("default",function(){return [(_vm.link.icon)?_c('i',{class:_vm.link.icon}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KGJ+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KaWC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-component"},[_c('div',{staticClass:"full-page section-image",attrs:{"data-color":"black"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-offset-3 col-md-6 ml-auto mr-auto form-login"},[_c('div',{staticClass:"form"},[_c('div',{staticClass:"card card-login"},[_c('div',{staticClass:"card-header"}),_vm._v(" "),_c('div',{staticClass:"card-body",class:{ shake: _vm.loginError }},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Пароль"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-wd",on:{"click":function($event){return _vm.login(_vm.username, _vm.password)}}},[_vm._v("Войти")])])])])]),_vm._v(" "),_c('div',{staticClass:"card-footer ml-auto mr-auto"})])])])])]),_vm._v(" "),_c('div',{staticClass:"full-page-background",style:({ backgroundImage: 'url(' + _vm.splash + ')' })})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L4th":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c51b0bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("+cI5");
function injectStyle (ssrContext) {
  __webpack_require__("uT4z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c51b0bd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MDnB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        DropDown: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Dropdown_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "MFnH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"li",staticClass:"dropdown nav-item",class:{show: _vm.isOpen},attrs:{"aria-haspopup":"true","aria-expanded":_vm.isOpen},on:{"click":_vm.toggleDropDown}},[_c('a',{staticClass:"nav-link dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[_vm._t("title",function(){return [_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"no-icon"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('b',{staticClass:"caret"})]})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],staticClass:"dropdown-menu"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MZ8R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__ = __webpack_require__("0FOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3ce4880_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__ = __webpack_require__("NTbq");
function injectStyle (ssrContext) {
  __webpack_require__("Qf8J")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b3ce4880_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__ = __webpack_require__("7SdG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        SidebarLink: __WEBPACK_IMPORTED_MODULE_0__SidebarLink_vue__["a" /* default */]
    },
    props: {
        title: {
            type: String,
            default: 'Aura'
        },
        backgroundColor: {
            type: String,
            default: 'black',
            validator: function validator(value) {
                var acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black'];
                return acceptedValues.indexOf(value) !== -1;
            }
        },
        backgroundImage: {
            type: String,
            default: '/static/img/muse1.jpg'
        },
        activeColor: {
            type: String,
            default: 'success',
            validator: function validator(value) {
                var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
                return acceptedValues.indexOf(value) !== -1;
            }
        },
        sidebarLinks: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        autoClose: {
            type: Boolean,
            default: true
        }
    },
    provide: function provide() {
        return {
            autoClose: this.autoClose
        };
    },

    computed: {
        sidebarStyle: function sidebarStyle() {
            return {
                backgroundImage: 'url(' + this.backgroundImage + ')'
            };
        }
    }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__light_bootstrap_main__ = __webpack_require__("28ys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__routes_routes__ = __webpack_require__("T1vP");





// LightBootstrap plugin


// router setup

// plugin setup
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4__light_bootstrap_main__["a" /* default */]);

// configure router
var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
    routes: __WEBPACK_IMPORTED_MODULE_5__routes_routes__["a" /* default */], // short for routes: routes
    linkActiveClass: 'nav-item active',
    mode: 'hash'
});

function nextFactory(context, middleware, index) {
    var subsequentMiddleware = middleware[index];

    if (!subsequentMiddleware) {
        return context.next;
    }

    return function () {
        context.next.apply(context, arguments);

        var nextMiddleware = nextFactory(context, middleware, index + 1);
        subsequentMiddleware(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context, { next: nextMiddleware }));
    };
}

router.beforeEach(function (to, from, next) {
    if (to.meta.middleware) {
        var middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware];

        var context = {
            from: from,
            next: next,
            router: router,
            to: to
        };

        var nextMiddleware = nextFactory(context, middleware, 1);

        return middleware[0](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, context, { next: nextMiddleware }));
    }

    return next();
});

__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$hostname = "https://affirmations.bigrowth.io";
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$storeVersion = 7;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue___default.a({
    el: '#app',
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_3__App_vue__["a" /* default */]);
    },
    router: router
});

/***/ }),

/***/ "NTbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"copyright text-center"},[_vm._v("\n            with\n            "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by\n            bigrowth team.\n        ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OG0z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.status),expression:"category.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.category.sort),callback:function ($$v) {_vm.$set(_vm.category, "sort", $$v)},expression:"category.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.category.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1937eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("yiba");
function injectStyle (ssrContext) {
  __webpack_require__("eApH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c1937eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OprI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("TiXa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e74f4154_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("HRq4");
function injectStyle (ssrContext) {
  __webpack_require__("R4eg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e74f4154"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e74f4154_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PBKA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Login',
    data: function data() {
        return {
            categories: [],
            username: 'admin',
            password: '',
            loginError: false,
            //splash: '/static/img/backgrounds/' + Math.floor((Math.random() * (5 - 1) + 1)).toString() + '.jpg'
            splash: '/static/img/backgrounds/3.jpg'
        };
    },

    created: function created() {
        if (localStorage.getItem('token')) {
            this.$router.push('/quotes');
        }
        document.getElementsByTagName("html")[0].style.height = "100vh";
    },
    methods: {
        login: function login(_login, password) {
            var self = this;
            self.loginError = false;

            axios.post(this.$hostname + '/admin/auth', {
                login: _login,
                password: password
            }).then(function (response) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('role', response.data.role);
                localStorage.setItem('new-auth', "302");

                self.$router.push('/quotes');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.loginError = true;

                // self.$notifications.notify(
                //     {
                //         component: notification,
                //         icon: 'nc-icon nc-simple-remove',
                //         horizontalAlign: 'right',
                //         verticalAlign: 'top',
                //         type: 'danger'
                //     })
            });
        }
    }
});

/***/ }),

/***/ "Pfth":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'is_premium', 'sort', 'count', 'status', ''],
            data: [],
            status: localStorage.getItem('c_status') ? localStorage.getItem('c_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/categories/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/categories/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('qq_categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-category',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('categories') < 1) {
            localStorage.setItem('c_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "QDyf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'card'
});

/***/ }),

/***/ "Qf8J":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qkg6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'l-table',
    props: {
        columns: Array,
        data: Array
    },
    methods: {
        hasValue: function hasValue(item, column) {
            return item[column.toLowerCase()] !== 'undefined';
        },
        itemValue: function itemValue(item, column) {
            return item[column.toLowerCase()];
        }
    }
});

/***/ }),

/***/ "QmVV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__ = __webpack_require__("EplD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bea82a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__ = __webpack_require__("U6vF");
function injectStyle (ssrContext) {
  __webpack_require__("uvNY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3bea82a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Create_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bea82a4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Create_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R4eg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e66b44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("++5V");
function injectStyle (ssrContext) {
  __webpack_require__("nFWD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16e66b44"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16e66b44_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SCCf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sczw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__ = __webpack_require__("eCSI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Login_vue__ = __webpack_require__("4pBi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Categories_vue__ = __webpack_require__("+iwA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Category_Create_vue__ = __webpack_require__("OprI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Category_Edit_vue__ = __webpack_require__("ndI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_ImagesCategories_vue__ = __webpack_require__("W8YO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_ImagesCategory_Create_vue__ = __webpack_require__("0hnZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_ImagesCategory_Edit_vue__ = __webpack_require__("3bYy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Quotes_vue__ = __webpack_require__("bbyC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Quote_Create_vue__ = __webpack_require__("QmVV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Quote_Edit_vue__ = __webpack_require__("WYKn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Images_vue__ = __webpack_require__("0lO5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Image_Create_vue__ = __webpack_require__("7OHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Image_Edit_vue__ = __webpack_require__("n1Iu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Icons_vue__ = __webpack_require__("U7xI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__middleware_Auth__ = __webpack_require__("X1HV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__middleware_Viewer__ = __webpack_require__("WiDG");

// GeneralViews


// Admin pages

















var routes = [{
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_2_src_components_Dashboard_Views_Login_vue__["a" /* default */]
}, {
    path: '/',
    redirect: "/quotes",
    component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard_Layout_DashboardLayout_vue__["a" /* default */],
    children: [{
        path: 'categories',
        name: 'Categories',
        component: __WEBPACK_IMPORTED_MODULE_3_src_components_Dashboard_Views_Categories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'categories/create',
        name: 'create-category',
        component: __WEBPACK_IMPORTED_MODULE_4_src_components_Dashboard_Views_Category_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'categories/:id',
        name: 'edit-category',
        component: __WEBPACK_IMPORTED_MODULE_5_src_components_Dashboard_Views_Category_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'quotes',
        name: 'Quotes',
        component: __WEBPACK_IMPORTED_MODULE_9_src_components_Dashboard_Views_Quotes_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'quotes/create',
        name: 'create-quote',
        component: __WEBPACK_IMPORTED_MODULE_10_src_components_Dashboard_Views_Quote_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'quotes/:id',
        name: 'edit-quote',
        component: __WEBPACK_IMPORTED_MODULE_11_src_components_Dashboard_Views_Quote_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'images-categories',
        name: 'ImagesCategories',
        component: __WEBPACK_IMPORTED_MODULE_6_src_components_Dashboard_Views_ImagesCategories_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'images-categories/create',
        name: 'create-images-category',
        component: __WEBPACK_IMPORTED_MODULE_7_src_components_Dashboard_Views_ImagesCategory_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'images-categories/:id',
        name: 'edit-images-category',
        component: __WEBPACK_IMPORTED_MODULE_8_src_components_Dashboard_Views_ImagesCategory_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'images',
        name: 'Images',
        component: __WEBPACK_IMPORTED_MODULE_12_src_components_Dashboard_Views_Images_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_17__middleware_Viewer__["a" /* default */]]
        }
    }, {
        path: 'images/create',
        name: 'create-image',
        component: __WEBPACK_IMPORTED_MODULE_13_src_components_Dashboard_Views_Image_Create_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'images/:id',
        name: 'edit-image',
        component: __WEBPACK_IMPORTED_MODULE_14_src_components_Dashboard_Views_Image_Edit_vue__["a" /* default */],
        meta: {
            middleware: [__WEBPACK_IMPORTED_MODULE_16__middleware_Auth__["a" /* default */]]
        }
    }, {
        path: 'icons',
        name: 'Icons',
        component: __WEBPACK_IMPORTED_MODULE_15_src_components_Dashboard_Views_Icons_vue__["a" /* default */]
        // meta: {
        //     middleware: [Auth]
        // },
    }]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_1__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "TI9T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.is_premium),expression:"category.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.category.is_premium)?_vm._i(_vm.category.is_premium,null)>-1:(_vm.category.is_premium)},on:{"change":function($event){var $$a=_vm.category.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.category, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.category, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.category, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.category.status),expression:"category.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.category, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.category.sort),callback:function ($$v) {_vm.$set(_vm.category, "sort", $$v)},expression:"category.sort"}}),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Количество цитат в категории","placeholder":"","readonly":""},model:{value:(_vm.category.count),callback:function ($$v) {_vm.$set(_vm.category, "count", $$v)},expression:"category.count"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.category.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.category)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TQ5B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__ = __webpack_require__("2aTV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__ = __webpack_require__("MZ8R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Content_vue__ = __webpack_require__("bwpC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__ = __webpack_require__("0AsC");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        TopNavbar: __WEBPACK_IMPORTED_MODULE_0__TopNavbar_vue__["a" /* default */],
        ContentFooter: __WEBPACK_IMPORTED_MODULE_1__ContentFooter_vue__["a" /* default */],
        DashboardContent: __WEBPACK_IMPORTED_MODULE_2__Content_vue__["a" /* default */],
        MobileMenu: __WEBPACK_IMPORTED_MODULE_3__MobileMenu_vue__["a" /* default */]
    },
    data: function data() {
        return {
            role: parseInt(localStorage.getItem('role')) || 0
        };
    },

    methods: {
        toggleSidebar: function toggleSidebar() {
            if (this.$sidebar.showSidebar) {
                this.$sidebar.displaySidebar(false);
            }
        },

        resetOffsets: function resetOffsets() {
            localStorage.setItem('w_active_offset', 0);
        }
    }
});

/***/ }),

/***/ "TiXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: {
                status: 0,
                is_premium: 0,
                translations: [],
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var category = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.category));

            category.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/categories/create', category, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "U6AA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar navbar-expand-lg"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"collapse navbar-collapse justify-content-end"},[_c('ul',{staticClass:"navbar-nav ml-auto"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",on:{"click":function($event){return _vm.logout()}}},[_vm._v("\n                        Выйти\n                    ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U6vF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.quote.category_id),expression:"quote.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.quote, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.quote.status),expression:"quote.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.quote, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.quote.sort),callback:function ($$v) {_vm.$set(_vm.quote, "sort", $$v)},expression:"quote.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit","disabled":!_vm.quote.sort},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.quote)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U72P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_0_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    }
});

/***/ }),

/***/ "U7xI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__ = __webpack_require__("U72P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ef38f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__ = __webpack_require__("EGO2");
function injectStyle (ssrContext) {
  __webpack_require__("ct9D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79ef38f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UMJ7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateAlbum',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            waiting: false,
            image: {
                status: 0,
                category_id: null,
                url: null,
                url_full: null,
                url_small: null,
                url_small_full: null,
                sort: 1
            },
            categories: JSON.parse(localStorage.getItem('ii_categories'))
        };
    },

    created: function created() {},
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        save: function save() {
            var self = this;

            var image = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.image));

            self.waiting = true;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/images/create', image, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0424\u043E\u043D \u0431\u044B\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.waiting = false;

                self.$router.push('/images');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });

                self.waiting = false;
            });
        },
        uploadFile: function uploadFile(event, type) {
            var self = this;

            var formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/services/file/upload', formData, {
                params: {
                    file_type: type
                },
                headers: {
                    'Authorization': 'Bearer ' + this.token,
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (response) {

                self.waiting = false;

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.image['' + type] = data.url;
                self.image[type + '_full'] = data.url_full;
            }).catch(function (error) {
                self.waiting = false;
                console.log(error);
            });
        }
    }
});

/***/ }),

/***/ "UjY0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Vcpj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var moment = __webpack_require__("PJh5");



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_3_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/categories/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.category = data.category;
                self.locales = data.locales;

                __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.map(self.locales, function (l) {
                    var tModel = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.find(self.category.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    console.log(self.category);
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var category = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.category));

            category.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/categories/' + this.id + '/update', category, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                //self.$router.push('/categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "VnhA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "W8YO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImagesCategories_vue__ = __webpack_require__("chhx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c807ba8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImagesCategories_vue__ = __webpack_require__("vDjh");
function injectStyle (ssrContext) {
  __webpack_require__("a1dH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c807ba8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImagesCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c807ba8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImagesCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WYKn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("jLHc");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cab967c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("bQ68");
function injectStyle (ssrContext) {
  __webpack_require__("D2tc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cab967c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cab967c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WiDG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Viewer;
function Viewer(_ref) {
    var next = _ref.next,
        router = _ref.router;

    if (!localStorage.getItem('token') || !localStorage.getItem('new-auth')) {
        return router.push({ name: 'login' });
    }

    return next();
}

/***/ }),

/***/ "X1HV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Auth;
function Auth(_ref) {
    var next = _ref.next,
        router = _ref.router;

    if (!localStorage.getItem('token') || !localStorage.getItem('new-auth')) {
        return router.push({ name: 'login' });
    }

    var role = localStorage.getItem('role');
    if (!role || role != 1) {
        return router.push({ name: 'login' });
    }

    return next();
}

/***/ }),

/***/ "YyF9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73211b65_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("MFnH");
function injectStyle (ssrContext) {
  __webpack_require__("rkeS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73211b65"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73211b65_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZyQS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'category', 'sort', 'status', ''],
            limit: 30,
            offset: parseInt(localStorage.getItem('qq_active_offset')) || 0,
            data: [],
            categories: [],
            quoteText: null,
            status: localStorage.getItem('qq_status') ? localStorage.getItem('qq_status') : "",
            categoryId: localStorage.getItem('qq_category') ? localStorage.getItem('qq_category') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.offset = 0;
            localStorage.setItem('qq_active_offset', parseInt(this.offset));

            this.get();
        },
        add: function add() {
            this.$router.push('/quotes/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            this.quoteText = this.quoteText === null ? '' : this.quoteText;

            //this.loading = true;

            axios.get(this.$hostname + '/admin/quotes/', {
                'params': {
                    status: self.status,
                    categoryId: self.categoryId,
                    quoteText: self.quoteText,
                    limit: self.limit,
                    offset: self.offset
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data.quotes;

                self.categories = response.data.categories;
                localStorage.setItem('qq_categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.categories));

                self.loading = false;
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-quote',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        },
        prev: function prev() {
            if (this.offset >= this.limit) {
                this.offset -= this.limit;
                this.get();
                localStorage.setItem('qq_active_offset', parseInt(this.offset));
            }
        },
        next: function next() {
            if (this.data.length === this.limit) {
                this.offset += this.limit;
                this.get();
                localStorage.setItem('qq_active_offset', parseInt(this.offset));
            }
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('quotes') < 1) {
            localStorage.setItem('qq_category', "");
            localStorage.setItem('qq_status', "");
            localStorage.setItem('qq_active_offset', "");
        }
        next();
    }
});

/***/ }),

/***/ "a1dH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aAG9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__ = __webpack_require__("Qkg6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb59baf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__ = __webpack_require__("kgzt");
function injectStyle (ssrContext) {
  __webpack_require__("vqQU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb59baf6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aKLM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'CreateCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: {
                status: 0,
                translations: [],
                sort: 1
            },
            locales: []
        };
    },

    created: function created() {
        this.getLocales();
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        getLocales: function getLocales() {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/services/locales', {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.locales = data.locales;
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var category = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.category));

            category.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/images-categories/create', category, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/images-categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }
    }
});

/***/ }),

/***/ "bQ68":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h5',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),(_vm.quote)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.quote.category_id),expression:"quote.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.quote, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.quote.status),expression:"quote.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.quote, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.quote.sort),callback:function ($$v) {_vm.$set(_vm.quote, "sort", $$v)},expression:"quote.sort"}})],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-remove",attrs:{"type":"button"},on:{"click":function($event){return _vm.remove()}}},[_vm._v("Удалить цитату\n                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("Локализация")]),_vm._v(" "),(_vm.quote)?_c('form',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},_vm._l((_vm.locales),function(itm,index){return _c('div',{key:index,staticClass:"content"},[_c('div',{staticClass:"control"},[_c('div',{staticClass:"field"},[_c('fg-input',{attrs:{"type":"text","label":_vm.locales[index].locale,"placeholder":""},model:{value:(_vm.locales[index].name),callback:function ($$v) {_vm.$set(_vm.locales[index], "name", $$v)},expression:"locales[index].name"}})],1)])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]):_vm._e()])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bbyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quotes_vue__ = __webpack_require__("ZyQS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4718b11b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quotes_vue__ = __webpack_require__("lweC");
function injectStyle (ssrContext) {
  __webpack_require__("HTVk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4718b11b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Quotes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4718b11b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Quotes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bwpC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__ = __webpack_require__("VnhA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb6051e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__ = __webpack_require__("KGJ+");
function injectStyle (ssrContext) {
  __webpack_require__("IRFK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Content_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2fb6051e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Content_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "chhx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__ = __webpack_require__("aAG9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var axios = __webpack_require__("mtWM");



/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        LTable: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Table_vue__["a" /* default */],
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    created: function created() {
        this.init();
    },
    data: function data() {
        return {
            columns: ['id', 'name', 'sort', 'count', 'status', ''],
            data: [],
            status: localStorage.getItem('ic_status') ? localStorage.getItem('ic_status') : "",
            loading: false
        };
    },

    methods: {
        init: function init() {
            this.get();
        },
        filter: function filter() {
            this.get();
        },
        add: function add() {
            this.$router.push('/images-categories/create');
        },
        get: function get() {
            var self = this;

            var token = localStorage.getItem('token');

            //this.loading = true;

            axios.get(this.$hostname + '/admin/images-categories/', {
                'params': {
                    status: this.status
                },
                'headers': {
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (response) {
                self.data = response.data;
                self.loading = false;
                localStorage.setItem('images-categories', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
            }).catch(function (error) {
                self.loading = false;
                console.log(error);
            });
        },
        edit: function edit(id) {
            this.$router.push({
                name: 'edit-images-category',
                params: { id: id }
            });
        },
        saveFilters: function saveFilters(name, value) {
            localStorage.setItem(name, value);
        }
    },
    beforeRouteLeave: function beforeRouteLeave(to, from, next) {
        if (to.path.indexOf('images-categories') < 1) {
            localStorage.setItem('ic_status', "");
        }
        next();
    }
});

/***/ }),

/***/ "ct9D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eApH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eCSI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__ = __webpack_require__("TQ5B");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d45e254_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__ = __webpack_require__("0AeP");
function injectStyle (ssrContext) {
  __webpack_require__("UjY0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DashboardLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d45e254_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DashboardLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    inheritAttrs: false,
    name: 'fg-input',
    props: {
        label: String,
        value: [String, Number],
        addonRightIcon: String,
        addonLeftIcon: String
    },
    computed: {
        hasIcon: function hasIcon() {
            var _$slots = this.$slots,
                addonRight = _$slots.addonRight,
                addonLeft = _$slots.addonLeft;

            return addonRight !== undefined || addonLeft !== undefined || this.addonRightIcon !== undefined || this.addonLeftIcon !== undefined;
        }
    }
});

/***/ }),

/***/ "iU4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditCategory',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            category: null,
            locales: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/images-categories/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.category = data.category;
                self.locales = data.locales;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.category.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var category = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.category));

            category.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/images-categories/' + this.id + '/update', category, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                //self.$router.push('/images-categories');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        }

    }
});

/***/ }),

/***/ "jEp+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__ = __webpack_require__("QDyf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5988fdbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__ = __webpack_require__("u6Ka");
function injectStyle (ssrContext) {
  __webpack_require__("YyF9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Card_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5988fdbd_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Card_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jLHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__ = __webpack_require__("jEp+");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var moment = __webpack_require__("PJh5");


/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EditQuote',
    components: {
        Card: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Cards_Card_vue__["a" /* default */]
    },
    data: function data() {
        return {
            id: null,
            token: localStorage.getItem('token'),
            quote: null,
            locales: [],
            categories: []
        };
    },

    created: function created() {
        this.id = this.$route.params.id;
        this.get(this.id);
    },
    methods: {
        goBack: function goBack() {
            window.history.back();
        },
        get: function get(id) {
            var self = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(this.$hostname + '/admin/quotes/' + this.id, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));

                self.quote = data.quote;
                self.locales = data.locales;
                self.categories = data.categories;

                _.map(self.locales, function (l) {

                    var tModel = _.find(self.quote.translations, function (t) {
                        return t.locale === l.locale;
                    });
                    l.name = tModel ? tModel.name : "";
                });
            }).catch(function (error) {

                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        save: function save() {
            var self = this;

            var quote = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quote));

            quote.translations = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.locales));

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/quotes/' + this.id + '/update', quote, {
                'headers': {
                    'Authorization': 'Bearer ' + this.token
                }
            }).then(function (response) {

                var notification = {
                    template: '<span><b>\u0426\u0438\u0442\u0430\u0442\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-explore-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'info'
                });

                self.$router.push('/quotes');
            }).catch(function (error) {
                var notification = {
                    template: '<span><b>' + error.response.data.message + '</b></span>'
                };

                self.$notifications.notify({
                    component: notification,
                    icon: 'nc-icon nc-simple-remove',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'danger'
                });
            });
        },
        remove: function remove() {
            var self = this;

            if (confirm("Подтверждение удаление цитаты")) {
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$hostname + '/admin/quotes/' + this.id + '/delete', {}, {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                }).then(function (response) {

                    var notification = {
                        template: '<span><b>\u0426\u0438\u0442\u0430\u0442\u0430 \u0431\u044B\u043B\u0430 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u0430</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-explore-2',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'info'
                    });

                    //self.$router.push('/quotes');
                }).catch(function (error) {
                    var notification = {
                        template: '<span><b>' + error.response.data.message + '</b></span>'
                    };

                    self.$notifications.notify({
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'danger'
                    });
                });
            }
        }
    }
});

/***/ }),

/***/ "kgzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[_vm._v(_vm._s(column))])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return (_vm.hasValue(item, column))?_c('td',[_vm._v(_vm._s(_vm.itemValue(item, column)))]):_vm._e()})},{"row":item})],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lweC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Цитаты")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.categoryId),expression:"categoryId"}],staticClass:"form-control",attrs:{"id":"category-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.categoryId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('qq_category', _vm.categoryId)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v(_vm._s(c.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('qq_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('fg-input',{attrs:{"type":"text","label":"Поиск по тексту","placeholder":""},model:{value:(_vm.quoteText),callback:function ($$v) {_vm.quoteText=$$v},expression:"quoteText"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить цитату\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("текст")]):(column === 'category')?_c('span',[_vm._v("категория")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активна")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активна")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.data.length < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.next.apply(null, arguments)}}},[_vm._v("\n                        След.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"pagination-button btn btn-warning btn-fill float-right",class:{ 'disabled' : _vm.offset < _vm.limit },on:{"click":function($event){$event.preventDefault();return _vm.prev.apply(null, arguments)}}},[_vm._v("\n                        Пред.\n                    ")])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n1Iu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("0uxu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e0deccb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("uJa7");
function injectStyle (ssrContext) {
  __webpack_require__("nCdi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e0deccb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e0deccb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nCdi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nFWD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ndI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__ = __webpack_require__("Vcpj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e54f160_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__ = __webpack_require__("TI9T");
function injectStyle (ssrContext) {
  __webpack_require__("L4th")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e54f160"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e54f160_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rkeS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'drop-down',
    props: {
        title: String,
        icon: String,
        tag: {
            type: String,
            default: 'li'
        }
    },
    data: function data() {
        return {
            isOpen: false
        };
    },

    methods: {
        toggleDropDown: function toggleDropDown() {
            this.isOpen = !this.isOpen;
            this.$emit('change', this.isOpen);
        },
        closeDropDown: function closeDropDown() {
            this.isOpen = false;
            this.$emit('change', this.isOpen);
        }
    }
});

/***/ }),

/***/ "u6Ka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[(_vm.$slots.image)?_c('div',{staticClass:"card-image"},[_vm._t("image")],2):_vm._e(),_vm._v(" "),(_vm.$slots.header)?_c('div',{staticClass:"card-header"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._t("default")],2),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uJa7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[(_vm.image)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('card',[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"link",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Назад")]),_vm._v(" -\n                        Общая информация")]),_vm._v(" "),_c('form',[_c('div',{staticClass:"row"},[(_vm.waiting)?_c('div',{staticClass:"loader"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label label-checkbox",attrs:{"for":"premium-control"}},[_vm._v("Премиум")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.image.is_premium),expression:"image.is_premium"}],staticClass:"form-check-inline",attrs:{"id":"premium-control","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.image.is_premium)?_vm._i(_vm.image.is_premium,null)>-1:(_vm.image.is_premium)},on:{"change":function($event){var $$a=_vm.image.is_premium,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.image, "is_premium", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.image, "is_premium", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.image, "is_premium", $$c)}}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Категория")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.image.category_id),expression:"image.category_id"}],staticClass:"form-control",attrs:{"id":"category-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.image, "category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.categories),function(c){return _c('option',{domProps:{"value":c.id}},[_vm._v("\n                                            "+_vm._s(c.name)+"\n                                        ")])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.image.status),expression:"image.status"}],staticClass:"form-control",attrs:{"id":"status-control","aria-describedby":"addon-right addon-left"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.image, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Активен")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активен")])])]),_vm._v(" "),_c('fg-input',{attrs:{"type":"text","label":"Сортировка (чем больше, тем выше в списке)","placeholder":""},model:{value:(_vm.image.sort),callback:function ($$v) {_vm.$set(_vm.image, "sort", $$v)},expression:"image.sort"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Фон: "),(_vm.image.url)?_c('span',[_c('a',{attrs:{"href":_vm.image.url_full,"target":"_blank"}},[_vm._v("(ссылка)")])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"urlFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'url')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.urlFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"device-block device1"},[_c('img',{attrs:{"src":_vm.image.url_full}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 buttons-block"},[_c('h4',{staticClass:"card-title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                                    Фон (превью): "),(_vm.image.url_small)?_c('span',[_c('a',{attrs:{"href":_vm.image.url_small_full,"target":"_blank"}},[_vm._v("(ссылка)")])]):_vm._e()]),_vm._v(" "),_c('div',[_c('input',{ref:"urlSmallFileInput",staticClass:"btn-file",attrs:{"type":"file"},on:{"change":function($event){return _vm.uploadFile($event, 'url_small')}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fill upload-button",attrs:{"type":"submit"},on:{"click":function($event){return _vm.$refs.urlSmallFileInput.click()}}},[_vm._v("\n                                        Загрузить\n                                    ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"})]),_vm._v(" "),_c('div',{staticClass:"device-block device1"},[_c('img',{attrs:{"src":_vm.image.url_small_full}})])])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-success btn-fill float-right btn-save",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.save.apply(null, arguments)}}},[_vm._v("\n                                Сохранить\n                            ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uT4z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uaxE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-ps": "zWlr",
	"./ar-ps.js": "zWlr",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku-kmr": "2ukb",
	"./ku-kmr.js": "2ukb",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uvNY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vDjh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Категории фонов")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('c_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить категорию\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'is_premium')?_c('span',[_vm._v("премиум")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):(column === 'count')?_c('span',[_vm._v("количество фонов")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === 'is_premium')?_c('span',[(item[column] === 1)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/premium.png"}}):_vm._e()]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активна")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активна")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vHPY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('card',[_c('template',{slot:"header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Категории цитат")]),_vm._v(" "),_c('p',{staticClass:"card-category"}),_vm._v(" "),_c('div',{staticClass:"row mt10"},[_c('div',{staticClass:"col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label"},[_vm._v("Статус")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control",attrs:{"id":"status-filter","aria-describedby":"addon-right addon-left"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.saveFilters('c_status', _vm.status)}]}},[_c('option',{attrs:{"value":"","selected":""}},[_vm._v("Все")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Активна")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Не активна")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-info btn-fill",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.filter.apply(null, arguments)}}},[_vm._v("\n                                    Фильтровать\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-fill float-right",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.add.apply(null, arguments)}}},[_vm._v("\n                                    Добавить категорию\n                                ")])])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table",class:{ 'loading-state': _vm.loading }},[_c('thead',[_vm._t("columns",function(){return _vm._l((_vm.columns),function(column){return _c('th',[(column === 'sort')?_c('span',[_vm._v("сортировка")]):(column === 'name')?_c('span',[_vm._v("название")]):(column === 'is_premium')?_c('span',[_vm._v("премиум")]):(column === 'status')?_c('span',[_vm._v("статус")]):(column === 'translations')?_c('span',[_vm._v("переводы")]):(column === 'count')?_c('span',[_vm._v("количество цитат")]):_c('span',[_vm._v(_vm._s(column))])])})})],2),_vm._v(" "),_c('tbody',_vm._l((_vm.data),function(item){return _c('tr',[_vm._t("default",function(){return _vm._l((_vm.columns),function(column){return _c('td',[(column === 'translations')?_c('span',[_vm._v(_vm._s(item[column]))]):(column === 'is_premium')?_c('span',[(item[column] === 1)?_c('img',{staticClass:"premium",attrs:{"src":"/static/img/premium.png"}}):_vm._e()]):(column === 'name')?_c('span',[_c('a',{staticClass:"text-default",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v(_vm._s(item[column]))])]):(column === '')?_c('span',[_c('a',{staticClass:"text-primary",on:{"click":function($event){return _vm.edit(item['id'])}}},[_vm._v("Изменить")])]):(column === 'status')?_c('span',[(item[column] === 1)?_c('span',{staticClass:"text-success"},[_vm._v("Активна")]):_vm._e(),_vm._v(" "),(item[column] === 0)?_c('span',{staticClass:"text-warning"},[_vm._v("Не активна")]):_vm._e()]):_c('span',[_vm._v(_vm._s(item[column]))])])})},{"row":item})],2)}),0)])])],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vqQU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "yiba":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group",class:{'input-group': _vm.hasIcon}},[_vm._t("label",function(){return [(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v("\n            "+_vm._s(_vm.label)+"\n        ")]):_vm._e()]}),_vm._v(" "),_vm._t("addonLeft",function(){return [(_vm.addonLeftIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonLeftIcon})]):_vm._e()]}),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control",attrs:{"aria-describedby":"addon-right addon-left"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("addonRight",function(){return [(_vm.addonRightIcon)?_c('span',{staticClass:"input-group-addon"},[_c('i',{class:_vm.addonRightIcon})]):_vm._e()]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zTLC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    computed: {
        routeName: function routeName() {
            var name = this.$route.name;

            return this.capitalizeFirstLetter(name);
        }
    },
    data: function data() {
        return {
            activeNotifications: false
        };
    },

    methods: {
        capitalizeFirstLetter: function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        toggleNotificationDropDown: function toggleNotificationDropDown() {
            this.activeNotifications = !this.activeNotifications;
        },
        closeDropDown: function closeDropDown() {
            this.activeNotifications = false;
        },
        toggleSidebar: function toggleSidebar() {
            this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
        },
        hideSidebar: function hideSidebar() {
            this.$sidebar.displaySidebar(false);
        },

        logout: function logout() {
            localStorage.removeItem('token');

            this.$router.push('/login');
        }
    }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.31dc1f273413556b357d.js